import React from 'react';
import type { ProductTabBlock, ProductTabTableModel } from 'autogen/swagger/all';
import TabBlock from '../../shared/TabBlock';
import Table from '../table';

type ProductTabTableListType = {
    productDosageBlocks: ProductTabBlock[];
    productTabTableModels: ProductTabTableModel[];
};

export default function TableList(props: ProductTabTableListType) {
    const { productDosageBlocks, productTabTableModels } = props;

    return (
        <div>
            {productDosageBlocks.map((block, i) => {
                const { content } = block;
                if (!content) return null;

                return (
                    // eslint-disable-next-line react/no-array-index-key
                    <TabBlock key={i} {...block} />
                );
            })}
            {productTabTableModels?.map((table, i) => {
                const { rows, tableHeaders } = table;
                if (!rows) return null;

                return (
                    // eslint-disable-next-line react/no-array-index-key
                    <Table key={i} type="Micronutrients" rows={rows} tableHeaders={tableHeaders} />
                );
            })}
        </div>
    );
}
